import i18next from 'i18next';
import { toast } from 'sonner';
import { bcmInitialResponseApi } from './bcm-initial-response.api';

export class BcmInitialResponseIntegration {
    constructor(service = bcmInitialResponseApi) {
        this.service = service;
    }

    async fetchItems(params = {}) {
        try {
            const response = await this.service.getAll(params);
            return {
                success: true,
                data: response.data,
                pagination: response.pagination || { total: response.total }
            };
        } catch (error) {
            toast.error(error.message || 'Fetch failed');
            return { success: false, error: error.message };
        }
    }

    async fetchRelated(bcpId, params = {}) {
        try {
            const response = await this.service.getRelated(bcpId, params);
            return {
                success: true,
                data: response.data,
                pagination: response.pagination
            };
        } catch (error) {
            toast.error(error.message || 'Fetch failed');
            return { success: false, error: error.message };
        }
    }

    async createItem(data) {
        try {
            const response = await this.service.create(data);
            toast.success(i18next.t('integrationToasts:bcmInitialResponseCreated', { defaultValue: 'Step created successfully' }));
            return { success: true, data: response.data };
        } catch (error) {
            toast.error(error.message || 'Create failed');
            return { success: false, error: error.message };
        }
    }

    async updateItem(id, data) {
        try {
            const response = await this.service.update(id, data);
            toast.success(i18next.t('integrationToasts:bcmInitialResponseUpdated', { defaultValue: 'Step updated successfully' }));
            return { success: true, data: response.data };
        } catch (error) {
            toast.error(error.message || 'Update failed');
            return { success: false, error: error.message };
        }
    }

    async deleteItem(id) {
        try {
            await this.service.delete(id);
            toast.success(i18next.t('integrationToasts:bcmInitialResponseDeleted', { defaultValue: 'Step deleted successfully' }));
            return { success: true };
        } catch (error) {
            toast.error(error.message || 'Delete failed');
            return { success: false, error: error.message };
        }
    }

    async linkItems(bcpId, stepIds) {
        try {
            const response = await this.service.link(bcpId, stepIds);
            toast.success(i18next.t('integrationToasts:bcmInitialResponseLinkedSuccessfully', { defaultValue: 'Steps linked successfully' }));
            return { success: true, data: response.data };
        } catch (error) {
            toast.error(error.message || 'Link failed');
            return { success: false, error: error.message };
        }
    }

    async unlinkItem(bcpId, stepId) {
        try {
            const response = await this.service.unlink(bcpId, stepId);
            toast.success(i18next.t('integrationToasts:bcmInitialResponseUnlinkedSuccessfully', { defaultValue: 'Step unlinked successfully' }));
            return { success: true, data: response.data };
        } catch (error) {
            toast.error(error.message || 'Unlink failed');
            return { success: false, error: error.message };
        }
    }

    async deleteItems(ids) {
        try {
            await this.service.batchDelete(ids);
            toast.success(i18next.t('integrationToasts:bcmInitialResponseDeleted', { defaultValue: 'Steps deleted successfully' }));
            return { success: true };
        } catch (error) {
            toast.error(error.message || 'Bulk delete failed');
            return { success: false, error: error.message };
        }
    }
}
